import React from "react";

const AlertIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="8" x2="12" y2="12" />
    <line x1="12" y1="16" x2="12.01" y2="16" />
  </svg>
);

const ErrorState = ({
  title = "Something went wrong",
  description = "Please try again. If the problem persists, contact support.",
  action,
  className = "",
}) => (
  <div className={`state ${className}`} role="alert">
    <div className="state__icon" style={{ background: "var(--danger-bg)", color: "var(--danger)" }} aria-hidden="true">
      <AlertIcon />
    </div>
    <h4 className="state__title">{title}</h4>
    {description && <p className="state__desc">{description}</p>}
    {action && <div className="state__cta">{action}</div>}
  </div>
);

export default ErrorState;
